import { render } from "./SaveLanguage.vue?vue&type=template&id=054190ee"
import script from "./SaveLanguage.vue?vue&type=script&lang=js"
export * from "./SaveLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__